import { useEffect, useRef } from 'react';

const getImageKey = (image) => {
  if (!image) {
    return null;
  }
  if (typeof image === 'string') {
    return image;
  }
  return `${image.name}:${image.size}:${image.lastModified}`;
};

const useInitialImage = ({ initialImage, editor, notice, viewport }) => {
  const loadedKeyRef = useRef(null);
  const key = getImageKey(initialImage);

  useEffect(() => {
    if (!key || loadedKeyRef.current === key) {
      return;
    }
    loadedKeyRef.current = key;
    notice
      .run(() => editor.loadBaseImage(initialImage), 'loadFailed')
      .then((applied) => {
        if (applied) {
          viewport.release();
        } else {
          loadedKeyRef.current = null;
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
};

export default useInitialImage;
